import angular from 'angular';
import { RegistrationGroup } from '../model/registrationGroup';
import moment from 'moment';
import SignalRService from '@/shared/services/SignalRService';

angular
  .module('cxRegistrations')
  .factory('registrationService', [
    'resourceFactorySvc',
    '$translate',
    '$http',
    'appUrls',
    '$q',
    '$http',
    registrationService,
  ]);

function registrationService(resourceFactorySvc, $translate, $http, appUrls, $q, http) {
  return {
    retrieveRegistrations: function(params, from, to, user) {
      var fromString = null;
      var params = {
        ...params,
      };

      if (typeof from === 'undefined') from = new Date();
      if (from instanceof Date) {
        fromString = moment(from).format('YYYY-MM-DD');
      } else if (typeof from === 'string') {
        fromString = from;
      }
      if (typeof to !== 'undefined' && typeof user !== 'undefined') {
        // registration overview call
        params.from = fromString;
        if (to instanceof Date) {
          params.to = moment(to).format('YYYY-MM-DD');
        } else if (typeof to === 'string') params.to = to;
        params.userId = user;
      } else {
        // registration by date call
        var deferred = $q.defer();
        return $http.get(`${appUrls.api}/api/registration/date/${fromString}`, {
          timeout: deferred.promise,
          cancel: deferred,
        });
      }

      var deferred = $q.defer();
      return $http.get(`${appUrls.api}/api/registration`, {
        params,
        timeout: deferred.promise,
        cancel: deferred,
      });
    },
    retrieveKpis: function(params, from, to, user) {
      var fromString = null;
      var params = {
        ...params,
      };

      if (typeof from === 'undefined') from = new Date();
      if (from instanceof Date) {
        fromString = moment(from).format('YYYY-MM-DD');
      } else if (typeof from === 'string') fromString = from;
      if (typeof to !== 'undefined' && typeof user !== 'undefined') {
        params.from = fromString;
        if (to instanceof Date) {
          params.to = moment(to).format('YYYY-MM-DD');
        } else if (typeof to === 'string') params.to = to;
        params.userId = user;
      } else params.id = fromString;

      return resourceFactorySvc.get('registration').kpi(params);
    },

    createGroup: function(registrations, date) {
      var reg = new RegistrationGroup();

      for (var j = 0; j < registrations.length; j++) {
        reg.setPart(registrations[j]);
      }

      reg.initDate(
        date ||
          moment
            .utc()
            .startOf('day')
            .toDate(),
      );
      reg.setRelation();
      return reg;
    },

    getNextRegistrationTime: function(date) {
      var deferred = $q.defer();

      $http
        .get(
          `${appUrls.api}/api/registration/LastRegistrationTime?date=${moment(date).format(
            'YYYY-MM-DD',
          )}`,
        )
        .then(
          function({ data }) {
            if (!data) {
              deferred.resolve({
                Hour: 9,
                Minute: 0,
              });
            }

            const momentDate = moment(data, 'HH:mm:ss');

            var h = momentDate.hour();
            var m = momentDate.minutes();

            deferred.resolve({
              Hour: h,
              Minute: m,
            });
          },
          function(error) {
            console.error(error);
            deferred.resolve({
              Hour: 9,
              Minute: 0,
            });
          },
        );
      return deferred.promise;
    },

    createReport: function(params, from, to, user) {
      var fromString = null;
      var params = {
        ...params,
      };
      if (typeof from === 'undefined') from = new Date();
      if (from instanceof Date) fromString = moment.utc(from).format('YYYY-MM-DD');
      else if (typeof from === 'string') fromString = from;

      if (typeof to !== 'undefined' && typeof user !== 'undefined') {
        params.from = fromString;
        if (to instanceof Date) params.to = moment.utc(to).format('YYYY-MM-DD');
        else if (typeof to === 'string') params.to = to;
        params.userId = user;
      } else params.id = fromString;

      params.languageCode = $translate.use();
      params.connectionId = SignalRService.getConnectionId();
      return resourceFactorySvc.get('registration').report(params);
    },
  };
}
